import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { describeStopFailureDetails, describeStopFailures } from "../utils/failure-message.js";

var root = $.from_html(`<div class="stop-failures svelte-14nf81h" role="status" aria-live="polite" aria-atomic="true"><span class="stop-failures-icon" aria-hidden="true">⚠</span> <span class="stop-failures-text svelte-14nf81h"> </span> <span class="stop-failures-hint svelte-14nf81h">keeps retrying</span></div>`);

const $$css = {
	hash: 'svelte-14nf81h',
	code: '.stop-failures.svelte-14nf81h {display:flex;align-items:center;justify-content:center;gap:0.5rem;flex-wrap:wrap;padding:0.25rem 0.75rem;font-size:clamp(0.9rem, 2vw, 1.3rem);line-height:1.3;background-color:#7f1d1d;color:#fef2f2;}[data-theme="light"] .stop-failures.svelte-14nf81h {background-color:#fee2e2;color:#991b1b;}[data-theme="dark"] .stop-failures.svelte-14nf81h {background-color:#7f1d1d;color:#fef2f2;}.stop-failures-text.svelte-14nf81h {font-weight:600;}.stop-failures-hint.svelte-14nf81h {opacity:0.8;}'
};

export default function StopFailures($$anchor, $$props) {
	$.push($$props, true);
	$.append_styles($$anchor, $$css);

	let failures = $.prop($$props, 'failures', 19, () => []);
	var fragment = $.comment();
	var node = $.first_child(fragment);

	{
		var consequent = ($$anchor) => {
			var div = root();
			var span = $.sibling($.child(div), 2);
			var text = $.only_child(span, true);

			$.next(2);
			$.reset(div);

			$.template_effect(
				($0, $1) => {
					$.set_attribute(div, 'title', $0);
					$.set_text(text, $1);
				},
				[
					() => describeStopFailureDetails(failures()),
					() => describeStopFailures(failures())
				]
			);

			$.append($$anchor, div);
		};

		$.if(node, ($$render) => {
			if (failures().length > 0) $$render(consequent);
		});
	}

	$.append($$anchor, fragment);
	$.pop();
}